"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "martignacco": {
    "4dc66f10": [{
      "hkey": "97085fb9",
      "slug": "ceresetto-torreano",
      "name": "Ceresetto-Torreano",
      "primary": true,
      "skipSearch": false
    }],
    "ceresetto": [{
      "hkey": "97085fb9",
      "slug": "ceresetto-torreano",
      "name": "Ceresetto-Torreano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "831215fb": [{
      "hkey": "6ff2457b",
      "slug": "faugnacco-nogaredo-di-prato",
      "name": "Faugnacco-Nogaredo di Prato",
      "primary": true,
      "skipSearch": false
    }],
    "faugnacco": [{
      "hkey": "6ff2457b",
      "slug": "faugnacco-nogaredo-di-prato",
      "name": "Faugnacco-Nogaredo di Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "martignacco"
    }],
    "c5e047b8": [{
      "hkey": "6ff2457b",
      "slug": "faugnacco-nogaredo-di-prato",
      "name": "Faugnacco-Nogaredo di Prato",
      "primary": true,
      "skipSearch": false
    }],
    "nogaredo-di-prato": [{
      "hkey": "6ff2457b",
      "slug": "faugnacco-nogaredo-di-prato",
      "name": "Faugnacco-Nogaredo di Prato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f4263c74": [{
      "hkey": "97085fb9",
      "slug": "ceresetto-torreano",
      "name": "Ceresetto-Torreano",
      "primary": true,
      "skipSearch": false
    }],
    "torreano": [{
      "hkey": "97085fb9",
      "slug": "ceresetto-torreano",
      "name": "Ceresetto-Torreano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "martignacco"
    }]
  }
};
exports["default"] = _default;